import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ProgressItem } from "@common/ADAPT.Common.Model/organisation/progress-item";
import { ProgressItemStatus, ProgressItemStatusMetadata } from "@common/ADAPT.Common.Model/organisation/progress-item-status";
import { ProgressProduct } from "@common/ADAPT.Common.Model/organisation/progress-product";
import { ProgressService } from "@common/progress/progress.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { journeyProgressPageRoute } from "@org-common/lib/journey-progress/journey-progress-page/journey-progress-page.component";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { lastValueFrom, Observable } from "rxjs";

@Component({
    selector: "adapt-journey-progress-dashboard-element",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./journey-progress-dashboard-element.component.html",
})
export class JourneyProgressDashboardElementComponent extends BaseComponent implements OnInit {
    public readonly ProgressItemStatus = ProgressItemStatus;
    public readonly ProgressItemStatusMeta = ProgressItemStatusMetadata.ByStatus;

    public progressProducts: ProgressProduct[] = [];
    public progressItems: ProgressItem[] = [];

    public url$?: Observable<string>;

    public constructor(
        private progressService: ProgressService,
        private organisationService: OrganisationService,
    ) {
        super();
    }

    public get progressPercent() {
        return ProgressService.getProgressPercent(this.progressItems);
    }

    public get progressText() {
        return ProgressService.getTooltipTextForItems(this.progressItems);
    }

    public async ngOnInit() {
        this.url$ = journeyProgressPageRoute.getRoute();
        await this.updateData();
    }

    public async updateData() {
        this.progressProducts = await lastValueFrom(this.progressService.getProgressProducts(this.organisationService.getOrganisationId()));
        this.progressItems = this.progressProducts.flatMap((p) => p.progressCategories.flatMap((c) => c.progressItems));
    }
}
